import React from 'react';
import PropTypes from 'prop-types';
import loaderImg from './loader-square-red.gif';

function MLLoading(props) {
  return (
    <img
      className={props.className || ''}
      src={loaderImg}
      role="presentation"
    />
  );
}

MLLoading.propTypes = {
  className: PropTypes.string,
};

export default MLLoading;
